/**
 * /app/beneficiaries — tenant-wide entry into the beneficiaries register.
 *
 * Replaced the legacy fixture redirect (hardcoded 'vandermerwe-family-trust').
 */

import { createFileRoute } from '@tanstack/react-router';
import { TrustScopedLanding } from '../../../components/screens/trust-scoped-landing';

export const Route = createFileRoute('/app/beneficiaries/')({
  component: () => (
    <TrustScopedLanding
      suffix="beneficiaries"
      eyebrow="Beneficiaries"
      title="Beneficiaries"
      emptyHelp="The beneficiaries register lists all natural and juristic persons recognised as beneficiaries of your trust. It appears here once a trust is onboarded."
    />
  ),
});
